// extracted by mini-css-extract-plugin
export default {"collection_bg":"styles_collection_bg__P8anr","collection_name":"styles_collection_name__I8GrR"};